<template>
  <div class="affiliate-register">
    <div class="container">
      <el-row type="flex" justify="center">
        <el-col :md="12">
          <el-card show type="primary">
            <h2>Become an Affiliate</h2>
            <p>
              Want to become an official PTDefender affiliate? Register below by entering your PTDefender License, choosing an affiliate name, and providing a BTC address that we will use to pay you commission.
            </p>
            <hr>
            <p>
              <strong>Important:</strong> Please do not include any spaces in your affiliate username to ensure a friendly link.
            </p>
            <el-form>
              <el-input v-model="license" type="text" placeholder="12345">
                <template slot="prepend">License</template>
              </el-input>
              <el-input v-model="name" type="text" placeholder="Ex. cryptokid5">
                <template slot="prepend">Username</template>
              </el-input>
              <el-input v-model="btcAddress" type="text" placeholder="AbCdeF1">
                <template slot="prepend">BTC Address</template>
              </el-input>
              <hr>
              <el-row type="flex" justify="end">
                <el-button @click="register" type="primary" :loading="loading" :disabled="!license || !name || !btcAddress || loading">
                  Register Affiliate
                </el-button>
              </el-row>
            </el-form>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import api from '@/lib/api'

export default {
  name: 'AffiliateRegister',
  data() {
    return {
      license: null,
      name: null,
      btcAddress: null,
      loading: false
    }
  },
  methods: {
    async register(event) {
      if (event) event.preventDefault()
      this.loading = true
      try {
        api.setLicense(this.license)
        await api.registerAffiliate({ license: this.license, name: this.name, btcAddress: this.btcAddress })
        this.license = null
        this.name = null
        this.btcAddress = null
        await this.$alert('Check your inbox for an email containing your PTDefender Affiliate link.', 'Registered')
      } catch(err) {
        api.setLicense(null)
        await this.$alert('This affiliate name may be taken, or you entered an invalid BTC address.', 'Something went wrong')
      }
      this.loading = false
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';
.affiliate-register {
  padding: 150px 8px 200px 8px;

  .el-input {
    margin: 10px auto;
    .el-input-group__prepend {
      width: 85px;
      padding: 0 14px;
    }
  }
}
</style>
